<template>
    <div v-if="hasPopular" class="container mx-auto flex flex-col py-6 pagetext-content">
        <div class="mx-4">
            <h2 class="search-title">
                <template v-if="isIndustryTown || isCounty || isTown || isRegion">
                    {{ locationPageTitle }}
                </template>
                <template v-else-if="isIndustryCounty">
                    {{ industryCountyPageTitle }}
                </template>
            </h2>
            <div class="horizontal-separator"></div>
            <ul class="md:columns-3">
                <li v-for="link in page_popular">
                    <static-search-link class="text-blue-30 text-xl leading-7" :key="link.url"
                    :to="link.url" :title="link.title">
                    {{ link.title }}
                    </static-search-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import StaticSearchLink from 'Components/StaticSearchLink';

export default {
    name: 'PopularLinks',
    components: {
        StaticSearchLink,
    },
    computed: {
        ...mapState('pagetext', ['pagetype', 'page_popular', 'location_name', 'industry']),
        ...mapGetters('pagetext', ['getPageType', 'isCounty', 'isTown', 'isIndustryTown', 'isIndustryCounty', 'isRegion']),
        hasPopular() { return (['town','county','industrycounty','region'].includes(this.getPageType) && this.page_popular.length > 0); },
        locationPageTitle() {
            return `Popular industry sectors in ${this.location_name}` 
                + (this.shouldSwitchHeadingTag() ? ' for recruitment agencies' : '');
        },
        industryCountyPageTitle() {
            return `Most Popular Towns for ${this.industry.industry_name_1} in ${this.location_name}`
            + (this.shouldSwitchHeadingTag() ? ' for recruitment agencies' : '');
        }
    }
}
</script>
